// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 网络协议枚举 枚举类
 * 网络协议枚举
 */
export enum EnumNetworkProtocol {
  /** HTTP : HTTP */
  HTTP = 1,
  /** HTTPS : HTTPS */
  HTTPS = 2
}

/**
 * 网络协议枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumNetworkProtocolMD {
  private static items = [
    new EnumItemMD('HTTP', 1, 'HTTP', 'HTTP'),
    new EnumItemMD('HTTPS', 2, 'HTTPS', 'HTTPS')
  ];

  static getItem(enumItem: EnumNetworkProtocol) {
    return this.items.find(item => item.name === EnumNetworkProtocol[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
